@if (loading) {
  <!-- No bloquea el mapa: el pedido de alarmas tarda unos segundos y sin esto
       la pantalla parecía vacía y sin nada cargando. -->
  <div class="mapa-cargando" role="status">
    <mat-progress-spinner
      mode="indeterminate"
      color="primary"
      [diameter]="20"
    ></mat-progress-spinner>
    <span>Cargando alarmas…</span>
  </div>
}
@if (alarmas && !loading) {
  <div class="mapa-flotante">
    <app-flotante-alarmas
      [alarmas]="alarmas"
      [vehiculosSeguridadPrivada]="reportesVehiculosSeguridadPrivada"
      [zonas]="zonas"
      (alarmaChange)="onAlarmaChange($event)"
      (clusterChange)="onClusterToggle($event)"
      (seguridadPrivadaChange)="onSeguridadPrivadaToggle($event)"
      (poligonoZonasChange)="onPoligonoZonasToggle($event)"
      (textoZonasChange)="onTextoZonasToggle($event)"
    ></app-flotante-alarmas>
  </div>
}
<app-mapa-facil-v2
  [center]="[-58.443832, -34.587386]"
  [zoom]="12"
  [style]="tipoMapaBase"
  [mapId]="'MapaAlarmasComponent'"
  [mapasPersonalizados]="mapasPersonalizados"
  [allowedEntityTypes]="allowedTypes"
  (mapReady)="onMapReady($event)"
></app-mapa-facil-v2>
